import { useContext } from 'react'
import { Outlet, RouterProvider, createBrowserRouter } from 'react-router'

import { ApolloProvider } from '@apollo/client'
import startup from 'startup'

import NotifyPopup from 'tools/Notify/Popup'
import { freeze } from 'utils/dom'
import { useUpdateQuerys } from 'utils/querys'

import { SignonProvider } from 'app/Auth/SignOn/Provider'
import Footer from 'libreon/Site/Footer'
import NavBar from 'libreon/Site/NavBar'
import { ErrorBoundary, ROUTES } from 'libreon/routes'
import 'libreon/style.scss'
import { GlobalContext, R_GLOBAL } from 'reducer/global'
import { useTheme } from 'reducer/global/hooks'
import { useSignon } from 'reducer/global/hooks'

const APPCFG = freeze({
  name: 'Libreon',
  nameLegal: 'Protos, LLC',
  logo: freeze({
    small: '/assets/img/libreon.svg',
    large: '/assets/img/libreon.svg'
  }),
  project: freeze({ singular: 'Title', icon: 'book', plural: 'Titles' }),
  org: freeze({ singular: 'Provider', icon: 'building', plural: 'Providers' })
})

const ROUTER = createBrowserRouter([
  {
    id: 'root',
    path: '/',
    ErrorBoundary,
    element: <LibreonRoot />,
    children: ROUTES
  }
])

function LibreonApp() {
  const hmrSafe = useContext(GlobalContext)
  if (!hmrSafe) {
    console.log('HMR reload lost GlobalContext')
    return <>Global context lost after HMR</>
  }
  const [{ apollo }] = hmrSafe
  return (
    <ApolloProvider client={apollo}>
      <SignonProvider>
        <WithSignon />
      </SignonProvider>
    </ApolloProvider>
  )
}

function WithSignon() {
  useTheme()
  useSignon()
  return <RouterProvider router={ROUTER} />
}

function LibreonRoot() {
  useUpdateQuerys(GlobalContext, R_GLOBAL.UPDATE_QUERY)
  return (
    <>
      <div id="body" className="base-body">
        <Outlet />
        <NotifyPopup />
      </div>
      <Footer />
      <NavBar />
    </>
  )
}

startup(APPCFG, LibreonApp)
